export class ApiService {
  private baseUrl = '/api';

  async get<T>(endpoint: string): Promise<T | null> {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        credentials: 'include', // Important: Send cookies for authentication
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (response.status === 401) {
        // Not authenticated - redirect to login
        window.location.href = '/login';
        return null;
      }
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`API GET error (${endpoint}):`, error);
      return null;
    }
  }

  async post<T>(endpoint: string, data?: any): Promise<T | null> {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: 'POST',
        credentials: 'include', // Important: Send cookies for authentication
        headers: { 'Content-Type': 'application/json' },
        body: data ? JSON.stringify(data) : undefined,
      });
      
      if (response.status === 401) {
        window.location.href = '/login';
        return null;
      }
      
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(`API POST error (${endpoint}):`, error);
      return null;
    }
  }

  async put<T>(endpoint: string, data?: any): Promise<T | null> {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: 'PUT',
        credentials: 'include', // Important: Send cookies for authentication
        headers: { 'Content-Type': 'application/json' },
        body: data ? JSON.stringify(data) : undefined,
      });
      
      if (response.status === 401) {
        window.location.href = '/login';
        return null;
      }
      
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(`API PUT error (${endpoint}):`, error);
      return null;
    }
  }

  async delete<T>(endpoint: string): Promise<T | null> {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: 'DELETE',
        credentials: 'include', // Important: Send cookies for authentication
      });
      
      if (response.status === 401) {
        window.location.href = '/login';
        return null;
      }
      
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(`API DELETE error (${endpoint}):`, error);
      return null;
    }
  }
}

export const api = new ApiService();
